import Payment from "src/components/feature/Payment";

const PaymentPage = () => {
  return <Payment />;
};

export default PaymentPage;
